import { Formatter } from '../../../../../hooks';
import { assert } from '../../../../util/assert';
import { AnyPersona, BillingSubscriptionPlan } from '../../../../domain/billing';
import {
    PersonaSelectControllerProps,
    PersonaSelectItemProps,
    PersonaSelectViewProps,
} from './personaListProps';

export function buildPersonaSelectProps(
    formatter: Formatter,
    props: PersonaSelectControllerProps
): PersonaSelectViewProps {
    let acc: Array<AnyPersona & { plan: BillingSubscriptionPlan }> = [];

    const free = props.plans.find((item) => item.amount === 0);
    const brand = props.plans.find((item) => item.type === 'brand' && item.amount > 0);
    const agency = props.plans.find((item) => item.type === 'agency');

    if (free) {
        acc = [
            ...acc,
            {
                kind: 'free',
                name: 'Free',
                plan: free,
            },
        ];
    }
    if (brand) {
        acc = [
            ...acc,
            {
                kind: 'brand',
                name: 'Brands',
                billing_unit: 'average monthly spend',
                plan: brand,
            },
        ];
    }
    if (agency) {
        acc = [
            ...acc,
            {
                kind: 'agency',
                name: 'Agencies',
                billing_unit: 'client',
                plan: agency,
            },
        ];
    }
    return {
        items: acc,
        getItemProps(item): PersonaSelectItemProps {
            const mapped = acc.find((candidate) => candidate.kind === item.kind);
            assert(mapped, 'not found');
            const priceLabel = formatter.currency(mapped.plan.amount / 100, 'usd');
            return {
                name: mapped.name,
                description: mapped.plan.description,
                price: {
                    label: `${priceLabel}/mo`,
                },
                isSelected: props.value === mapped.kind,
                onSelectClick() {
                    props.onChange(mapped.kind);
                },
            };
        },
    };
}
